var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18NLink, t, Translate } from "../../I18N";
import {
deleteRelationType,
checkRelationTypeCanBeDeleted } from "../../RelationTypes/actions/relationTypesActions";

import relationTypesAPI from "../../RelationTypes/RelationTypesAPI";
import RouteHandler from "../../App/RouteHandler";
import { Icon } from "../../UI";
import { actions } from "../../BasicReducer";
import { notify } from "../../Notifications/actions/notificationsActions";
import { SettingsHeader } from "./SettingsHeader";

class RelationTypesList extends RouteHandler {
  static async requestState(requestParams) {
    const relationTypes = await relationTypesAPI.get(requestParams.onlyHeaders());
    return [actions.set('relationTypes', relationTypes)];
  }

  deleteRelationType(relationType) {
    return this.props.
    checkRelationTypeCanBeDeleted(relationType).
    then(() => {
      this.context.confirm({
        accept: () => {
          this.props.deleteRelationType(relationType);
        },
        title: /*#__PURE__*/
        React.createElement(React.Fragment, null, /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Confirm delete relationship type:"), "\xA0", relationType.name),


        message: 'Are you sure you want to delete this relationship type?'
      });
    }).
    catch(() => {
      this.context.confirm({
        accept: () => {},
        noCancel: true,
        title: /*#__PURE__*/
        React.createElement(React.Fragment, null, /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Cannot delete relationship type:"), "\xA0", relationType.name),


        message: 'This relationship type is being used and cannot be deleted.'
      });
    });
  }

  render() {
    return /*#__PURE__*/(
      _jsx("div", { className: "settings-content" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "panel panel-default" }, void 0, /*#__PURE__*/
      _jsx(SettingsHeader, {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Relationship types")), /*#__PURE__*/

      _jsx("ul", { className: "list-group relation-types" }, void 0,
      this.props.relationTypes.toJS().map((relationType, index) => /*#__PURE__*/
      _jsx("li", { className: "list-group-item" }, index, /*#__PURE__*/
      _jsx(I18NLink, { to: `/settings/connections/edit/${relationType._id}` }, void 0,
      relationType.name), /*#__PURE__*/

      _jsx("div", { className: "list-group-item-actions" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, {
        to: `/settings/connections/edit/${relationType._id}`,
        className: "btn btn-default btn-xs" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "pencil-alt" }), "\xA0", /*#__PURE__*/

      _jsx("span", {}, void 0, t('System', 'Edit'))), /*#__PURE__*/

      _jsx("a", {
        onClick: this.deleteRelationType.bind(this, relationType),
        className: "btn btn-danger btn-xs template-remove" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "trash-alt" }), "\xA0", /*#__PURE__*/

      _jsx("span", {}, void 0, t('System', 'Delete'))))))), /*#__PURE__*/





      _jsx("div", { className: "settings-footer" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, { to: "/settings/connections/new", className: "btn btn-default" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "plus" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Add relationship')))))));





  }
}

RelationTypesList.propTypes = {
  relationTypes: PropTypes.object,
  deleteRelationType: PropTypes.func,
  notify: PropTypes.func,
  checkRelationTypeCanBeDeleted: PropTypes.func
};

RelationTypesList.contextTypes = {
  confirm: PropTypes.func,
  store: PropTypes.object
};

function mapStateToProps(state) {
  return { relationTypes: state.relationTypes };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
  { notify, deleteRelationType, checkRelationTypeCanBeDeleted },
  dispatch);

}

export { RelationTypesList, mapStateToProps };

export default connect(mapStateToProps, mapDispatchToProps)(RelationTypesList);